/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Weighings_TitleInputs */

const vi_my_weighings_title = /** @type {(inputs: My_Weighings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số cân của tôi`)
};

/**

* @param {My_Weighings_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_weighings_title = /** @type {((inputs?: My_Weighings_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Weighings_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_weighings_title(inputs)
});